import { Address } from '../../models/Address';

export const getShortAddress = (address: Address): string => {
  return `${address.zipCode}, ${address.city}`;
};
